import { memo, useEffect, useRef, useState } from "react";
import { ENEMY_RADIUS } from "./constants";
import { identityVector, vectorSub } from "./math";
import { Box, Container } from "./react-graphics";

type Props = {
  x: number;
  y: number;
  damaged: boolean;
};

function usePrevious<T>(value: T) {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const Enemy = ({ x, y, damaged }: Props) => {
  const previousX = usePrevious(x);
  const previousY = usePrevious(y);
  const [rotation, setRotation] = useState(0);
  useEffect(() => {
    if (previousX === undefined || previousY === undefined) {
      return;
    }
    if (x === previousX && y === previousY) {
      return;
    }
    const direction = identityVector(
      vectorSub({ x, y }, { x: previousX, y: previousY })
    );
    if (direction.x === 0 && direction.y === 0) {
      return;
    }
    setRotation(Math.atan2(direction.x, direction.y));
  }, [x, y, previousX, previousY]);
  return (
    <Container x={x} y={-y} rotation={rotation}>
      <Box
        x={0}
        y={0}
        width={1.4 * ENEMY_RADIUS}
        height={ENEMY_RADIUS}
        fillColor={damaged ? 0x4444444 : 0x000000}
        pivotX={0.5}
        pivotY={0.5}
      />
      <Box
        x={-0.7 * ENEMY_RADIUS}
        y={0}
        width={0.1 * ENEMY_RADIUS}
        height={2 * ENEMY_RADIUS}
        fillColor={damaged ? 0x4444444 : 0x000000}
        pivotX={0.5}
        pivotY={0.5}
      />
      <Box
        x={0.7 * ENEMY_RADIUS}
        y={0}
        width={0.1 * ENEMY_RADIUS}
        height={2 * ENEMY_RADIUS}
        fillColor={damaged ? 0x4444444 : 0x000000}
        pivotX={0.5}
        pivotY={0.5}
      />
    </Container>
  );
};

export default memo(Enemy);
